import React, { useEffect } from "react";
import Head from "@/shared/lib/router/head";
import { useRouter } from "@/shared/lib/router/router";
import DashboardShell from "@/shared/ui/DashboardShell";
import { ROUTES } from "@/shared/config/routes";

export default function AdminAppReleasesPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace(ROUTES.adminAppHub);
  }, [router]);

  return (
    <DashboardShell>
      <Head>
        <title>Hub dos Apps | 7DAYS</title>
      </Head>
      <div className="p-8 text-center text-sm text-dark_gray dark:text-zinc-400">
        A redirecionar para o Hub dos Apps...
      </div>
    </DashboardShell>
  );
}


